import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';

import EditableReportSaveAsModal from '../../report-saving/EditableReportSaveAsModal/EditableReportSaveAsModal';
import EditReportButton from '../EditReportButton/EditReportButton';
import SaveReportButton from '../SaveReportButton/SaveReportButton';

const EditableReportButtons = ({shouldDisplay = false}) => {
  if (!shouldDisplay) return null;

  return (
    <Box sx={{position: 'fixed', bottom: 6}}>
      <Grid container justifyContent="center" spacing={1}>
        <Grid item>
          <EditReportButton />
        </Grid>
        <Grid item>
          <SaveReportButton />
        </Grid>
      </Grid>
      <EditableReportSaveAsModal />
    </Box>
  );
};

EditableReportButtons.propTypes = {
  shouldDisplay: PropTypes.bool.isRequired
};

export default EditableReportButtons;
